import { Navigate } from 'react-router-dom'; 
import useAuth from '../hooks/useAuth';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = useAuth();  // Get the authentication status
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
